import { FeatureName, useCurrentAccount, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideLayout, ViewMode } from '@gripp/shared-ui';
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { Profile } from '../../profile/components/profile';
import { AccountPage } from './components/accountPage';
import { SettingMenu } from './components/settingMenu';

export const Settings: React.FC = () => {
  // TODO: Crop Circle Redesign | Remove feature flag check after full rollout
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign | Return old Profile component when flag is OFF
  if (!isCropCircleRedesignEnabled) {
    return <Profile />;
  }

  // TODO: Crop Circle Redesign | Remove SettingsBase after full rollout
  return <SettingsBase />;
};

const SettingsBase: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { account } = useCurrentAccount();

  const isChildRoute = location.pathname !== '/settings';

  // redirect to profile settings if user doesn't have a workspace and tries to access workspace settings
  if (!account?.workspace && !isChildRoute) {
    navigate('/settings/profile');
  }

  const leftColumn = {
    title: 'preferences.settings.title',
    mainComponent: <SettingMenu />,
  };

  const rightColumn = {
    title: 'accountPage.menu.workspaceSettingsPage',
    mainComponent: isChildRoute ? <Outlet /> : <AccountPage />,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
